import styled from 'styled-components';

export const StyledBoard = styled('div')`
  border: 7px solid #fff;
  margin-top: 30px;
  background: #397723;
  height: 630px;
  width: 100%;
  position: relative;
  z-index: 1;

  
  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 600px) {
    height 250px;
    border: 4px solid #fff;
    &::before {
      width:4px; 
    }
    &::after {
      width: 4px;
    }
    .counter-text{
      font-size: 50px;
    }
  }
  @media only screen and (max-width: 768px) {
    height 450px;
    border: 5px solid #fff;
    &::before {
      width:5px; 
    }
    &::after {
      width: 5px;
    }
    .counter-text{
      font-size: 60px;
    }
  }
 

  &::before {
    position: absolute;
    left: 50%;
    top: 0;
    content: '';
    background: #fff;
    height: 100%;
    width: 7px;
    transform: translateX(-50%);
    box-shadow: 10px 0px 4px 0px #0000007a;
    z-index: -1;
    @media only screen and (max-width: 600px) {
        width:4px; 
        box-shadow: 5px 0px 4px 0px #0000007a;
    }
    @media only screen and (max-width:768px) {
        width:5px; 
        box-shadow: 6px 0px 4px 0px #0000007a;
    }
  }
  &::after {
    position: absolute;
    left: 0;
    top: 50%;
    content: '';
    background: #fff;
    height: 7px;
    width: 100%;
    transform: translateY(-50%);
    z-index: -2;
    @media only screen and (max-width: 600px) {
      height:4px; 
  }
    @media only screen and (max-width: 768px) {
      height:5px; 
  }
  }
  .ball {
    position: absolute;
    left: 3%;
    top: 50%;
    z-index: 2;
    max-width: 45px;
    cursor: pointer;
    z-index: 999;
    margin-top: -25px;
    @media only screen and (max-width: 600px) {
      max-width: 30px;
      margin-top: -15px
    }
    @media only screen and (max-width: 768px) {
      max-width: 35px;
      margin-top: -20px
    }
  }

  .counter-text {
    font-size: 150px;
    text-align: center;
    margin: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    text-shadow: 3px 3px 0 #fff, -1px -1px 0 #fff, 1px -1px 0 #fff,
      -1px 1px 0 #fff, 1px 1px 0 #fff;
    color: #e02f29 !important;

    @media only screen and (max-width: 600px) {
      font-size: 70px;
    } 
  }

  .custom-alert {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000000b0;
    z-index: 999;
    position: absolute;

    h2 {
      margin: 0;
      text-shadow: 3px -3px 0 #fff, 3px 3px 0 #fff, -2px 1px 0 #fff,
        -3px 3px 0 #fff, -4px -3px 0 #fff;
      color: #e02f29 !important;
      font-size: 130px;
      
      @media only screen and (max-width: 600px) {
        font-size: 55px;
      }
    }
  }
`;

export const Ball = styled('img')`
  position: absolute;
  left: 3%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  max-width: 60px;
  cursor: pointer;
`;
export const Cups = styled('img')`
  position: absolute;
  right: 3%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  max-width: 235px;

  @media only screen and (max-width: 600px) {
    max-width: 90px;
  }
  @media only screen and (max-width: 768px) {
    max-width: 140px;
  }
`;

export const PopupText = styled('h4')`
  text-shadow: 3px 3px 0 #fff, -1px -1px 0 #fff, 1px -1px 0 #fff,
    -1px 1px 0 #fff, 1px 1px 0 #fff;
  color: #e02f29;
`;

export const Container = styled('div')`
  max-width: 1200px;
  margin: 0 auto;
`;
export const Root = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 10px;
  @media only screen and (max-width: 600px) {
    height: 50vh;
  }

  @media only screen and (max-width: 768px) {
    height: 80vh;
  }
`;

// /* Extra small devices (phones, 600px and down) */
// @media only screen and (max-width: 600px) {...}

// /* Small devices (portrait tablets and large phones, 600px and up) */
// @media only screen and (min-width: 600px) {...}

// /* Medium devices (landscape tablets, 768px and up) */
// @media only screen and (min-width: 768px) {...}

// /* Large devices (laptops/desktops, 992px and up) */
// @media only screen and (min-width: 992px) {...}

// /* Extra large devices (large laptops and desktops, 1200px and up) */
// @media only screen and (min-width: 1200px) {...}
